

import React from "react";
import { useTranslation } from "react-i18next";
import { Modal,Button } from "react-bootstrap";

const FileModal = ({ show, handleHide, title, text,handleAddFile,setDocument }) => {
  const { t: translator } = useTranslation();

  return (
    <Modal show={show} onHide={handleHide}>
          <Modal.Header>
            <h2 style={{ fontSize: "14px" }}>{translator("Add new file")}</h2>
          </Modal.Header>
          <Modal.Body>
             <input
                  type="file"
                  className="form-control-file"
                  name="file"
                  onChange={() =>
                  {
                    console.log("file",document.getElementsByName("file")[0].files[0]);
                    setDocument(document.getElementsByName("file")[0].files[0]);

                  }
                  }
                />
          </Modal.Body>
          <Modal.Footer style={{ display: "flex", justifyContent: "flex-end" }}>
            
            <button onClick={handleHide} className="btn btn-outline-secondary">
              {translator("Cancel")}
            </button>
            <Button
              onClick={handleAddFile}
              appearance="primary"
            >
              {translator("Add")}
            </Button>
          </Modal.Footer>
        </Modal>
    
  );
};

export default FileModal;
